import { render, staticRenderFns } from "./PanelHeaderButton.vue?vue&type=template&id=51eb6c36&"
import script from "./PanelHeaderButton.vue?vue&type=script&lang=ts&"
export * from "./PanelHeaderButton.vue?vue&type=script&lang=ts&"
import style0 from "./PanelHeaderButton.vue?vue&type=style&index=0&id=51eb6c36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports